import { BillingContact } from './Contact';

export enum PaymentType {
  Unknown = -1,
  CreditCard = 0,
  OnAccount = 1,
}

export interface ADFPaymentRequest {
  paymentAmount: number;
  paymentType: PaymentType;
  creditCardToken: string;
  creditCardExpirationDate: string;
  billingContact: BillingContact;
}
